export default {
  apiUrl: window.url ? window.url : process.env.VUE_APP_API_URL,
  clientId: process.env.VUE_APP_API_CLIENT_ID,
  clientSecret: process.env.VUE_APP_API_CLIENT_SECRET,
  mapboxAccessToken: process.env.VUE_APP_MAPBOX_TOKEN,
  googleMapsApiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  demoEmail: process.env.VUE_APP_DEMO_EMAIL,
  demoPassword: process.env.VUE_APP_DEMO_PASSWORD,
};
